'use client'

import { toast } from 'sonner'

import { StepRenderer } from '../../../../components/setup-workspace/step-renderer'
import { ANALYTICS_PAGES } from '../../../../constants/analytics'
import { WorkspaceSetupProvider } from '../../../../contexts/setup-workspace-context'
import { usePageView } from '../../../../hooks/use-page-view'
import { useCarrierOnboarding } from '../_context/carrier-onboarding-context'

export const CarrierMCOrDOTVerification = () => {
  usePageView(ANALYTICS_PAGES.carrierMcDotVerification)
  const { markStepAsCompleted } = useCarrierOnboarding()

  const handleOnClose = () => {
    toast.success('Your business has been verified successfully')
    markStepAsCompleted('mc_dot')
  }

  return (
    <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div className="sm:rounded-lg sm:px-10">
        <div className="mb-6 text-center">
          <div className="text-4xl mb-2">🚛</div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-200">Verify your MC / DOT number</h2>
          <p className="mt-2 text-sm text-gray-600 dark:text-gray-200">This helps us verify your business.</p>
        </div>

        {/* Wrap in proper context providers */}
        <WorkspaceSetupProvider>
          <StepRenderer onClose={handleOnClose} />
        </WorkspaceSetupProvider>
      </div>
    </div>
  )
}
